module.exports = __webpack_public_path__ + "static/media/impressum.62e595ae.svg";